import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[clickedOutside]',
})
export class ClickedOutsideDirective {
    @Output() clickedOutside = new EventEmitter<MouseEvent>();
    private listening = false;

    constructor(private _elementRef: ElementRef) {}

    ngAfterViewInit() {
        // Start listening after a short delay
        setTimeout(() => (this.listening = true));
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!this.listening) return;
        const target = event.target as Node;
        if (target && !this._elementRef.nativeElement.contains(target)) {
            this.clickedOutside.emit(event);
        }
    }
}
